import { MouseEvent } from 'react';
import { useRouter } from 'next/router';

import Image from 'global/Image';
import useMultiPortfolioStore from 'lib/stores/multiPorto';
import { formatCurrency } from 'features/securities/withdrawal/utils';
import { getRoundDownValue } from 'features/securities/utils';

import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';
import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';

import {
  Container,
  ContentWrapper,
  FinishButton,
  CashTransferTitle,
  CashTransfered,
} from './cash-success.styled';

const TransferCashSuccess = ({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: BaseSecuritiesModalProps) => {
  const router = useRouter();

  const moveCashForm = useMultiPortfolioStore((s) => s.moveCashForm);
  const resetMoveCashForm = useMultiPortfolioStore((s) => s.resetMoveCashForm);
  const resetWithdrawableBalance = useMultiPortfolioStore(
    (s) => s.resetWithdrawable,
  );

  const handleReset = () => {
    resetMoveCashForm();
    resetWithdrawableBalance();

    router.push('/securities/history');
  };

  const handleSubmit = () => {
    onSubmit();
    handleReset();
  };

  const handleCancel = (e: MouseEvent<HTMLElement>) => {
    onCancel(e);
    handleReset();
  };

  return (
    <BaseSecuritiesModal
      hideSubmit
      onCancel={handleCancel}
      className="modal-multi-porto"
      transitionName=""
      {...props}
    >
      <Container onClick={(e) => e.stopPropagation()}>
        <Image src="/images/multi-porto/success-transfer-cash.svg" alt="" />

        <ContentWrapper>
          <CashTransferTitle>Cash Transfer Successful</CashTransferTitle>
          <CashTransfered>
            {formatCurrency(String(getRoundDownValue(moveCashForm.amount, 2)))}
          </CashTransfered>
        </ContentWrapper>

        <FinishButton onClick={handleSubmit} type="primary">
          Close
        </FinishButton>
      </Container>
    </BaseSecuritiesModal>
  );
};

export default TransferCashSuccess;
